module.exports = __webpack_public_path__ + "img/thomas_fonk.81313bf4.png";